import { useContext } from 'react';
import { hashExistInFiles } from '../../../utils/fileHelpers';
import { appContext } from '../../../AppContext';
import CheckIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import XIcon from '@mui/icons-material/CancelOutlined';

const ValidationResult = ({ historyItem }) => {
  const { files } = useContext(appContext);

  return (
    <div className="flex items-center gap-2">
      {+historyItem.VALID === 0 ? (
        <>
          <XIcon className="text-minima-core-orange" />
          <p>No match</p>
        </>
      ) : +historyItem.VALID === 1 ? (
        <>
          {historyItem.VALIDATION_RESULT === 'full match' ? (
            <>
              <CheckIcon className="text-green-500" />
              <p>Full match</p>
            </>
          ) : (
            historyItem.VALIDATION_RESULT === 'partial match' && (
              <>
                <CheckIcon className="text-yellow-700" />
                <p>Partial match</p>
              </>
            )
          )}
        </>
      ) : +historyItem.VALID === 2 ? (
        hashExistInFiles(files, historyItem.HASH) ? (
          <p>Not Verified</p>
        ) : (
          <p>Not Verified</p>
        )
      ) : null}
    </div>
  );
};
export default ValidationResult;
